// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ApprovableContainer } from "@modules/service/types";
import type { RtwStateType, Rtw } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

//Live Processes

export const onResetRtwState = (state: RtwStateType) => () => ({
  ...state,
  current: null,
  draft: null,
  assignments: [],
});

export const onDisableRtw = (state: RtwStateType) => () => startRequest(state);
export const onDisableRtwSuccess = (state: RtwStateType) => () => finishRequest(state);
export const onDisableRtwError = (state: RtwStateType) => () => finishRequest(state);

export const onAddRtw = (state: RtwStateType) => () => startRequest(state);
export const onAddRtwSuccess = (state: RtwStateType) => () => finishRequest(state);
export const onAddRtwError = (state: RtwStateType) => () => finishRequest(state);

export const onSetRTWLiveProcessesFilter = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  liveProcessesFilter: payload,
});

export const onGetRtwProcesses = (state: RtwStateType) => () => startRequest(state);

export const onGetRtwProcessesSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetRtwProcessesError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Record

export const onGet = (state: RtwStateType) => () => startRequest(state);

export const onGetSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Schema

export const onGetSchema = (state: RtwStateType) => () => startRequest(state);

export const onGetSchemaSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: RtwStateType) => (action: Action<void>) => ({
  ...state,
  draft: {},
});

export const onStartDraftSuccess = (state: RtwStateType) => ({
  payload,
}: Action<ApprovableContainer<Rtw>>) => ({
  ...state,
  draft: (payload && payload.active) || {},
});

export const onSetRtwDraft = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});

export const onNewAssignments = (state: RtwStateType) => (action: Action<void>) => ({
  ...state,
  assignments: [],
});

export const onSetAssignments = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetRtwDraftAssignments = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  draftAssignments: payload,
});

// Config

export const onSetEnabled = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    enabled: payload,
  },
});

// Modals

export const onSetShowAddRtwAttachmentModal = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddRtwAttachmentModal: payload,
  },
});
export const onUpdateRtw = (state: RtwStateType) => () => startRequest(state);
export const onUpdateRtwSuccess = (state: RtwStateType) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  current: {
    ...state.current,
    active: payload,
  },
});
export const onUpdateRtwError = (state: RtwStateType) => () => finishRequest(state);

type OnChangeAddFileInProgressPayload = {
  addFileInProgress: any,
};
export const onChangeAddFileInProgress = (state: RtwStateType) => (
  action: Action<OnChangeAddFileInProgressPayload>,
) => {
  const { addFileInProgress } = action.payload || {};

  return {
    ...state,
    addFileInProgress,
  };
};
